const PhantomData = [
    {
        'key': 0,
        'name': 'Ash',
        'gender': 'Male',
        'type': 'Human',
        'weight': 110,
        'age': 18,
        'height': `5'6"`,
        'ability': 'Ability of the Water Dragon, Eccarlate',
        'desc': 'Ash is Marona’s guardian. He is a kind young man with a strong sense for justice. Before his death, Ash worked as a Chroma with Marona’s parents.',
        'img': './img/phantom-char/ash.png',
        'head': './img/phantom-char/ash-head.png'
    },
    {
        'key': 1,
        'name': 'Marona',
        'gender': 'Female',
        'type': 'Human',
        'weight': 68,
        'age': 13,
        'height': `4’6”`,
        'ability': 'The miracle ability, Chartreuse Gale ',
        'desc': 'Marona has the ability to control phantoms. This ability enables her to work as a Chroma, but unfortunately, her powers are despised by others. ',
        'img': './img/phantom-char/marona.png',
        'head': './img/phantom-char/marona-head.png'
    },
    {
        'key': 2,
        'name': 'Castile',
        'gender': 'Female',
        'type': 'Human',
        'weight': 86,
        'age': 13,
        'height': `4’7”`,
        'ability': 'None',
        'desc': 'Because Castile has been ill since the day she was born, she doesn’t know the outside world. She hates herself for not being able to help others.',
        'img': './img/phantom-char/castile.png',
        'head': './img/phantom-char/castile-head.png'
    },
    {
        'key': 3,
        'name': 'Putty',
        'gender': 'Unknown',
        'type': 'Putty',
        'weight': 3.3,
        'age': '~200',
        'height': `1'5"`,
        'ability': 'Ability to hide objects through control of time and space',
        'desc': 'Because of their habit of hiding objects, they are referred to as the “thieves of the forest” and have been hated since ancient times. They do not understand human language, but are highly intelligent.',
        'img': './img/phantom-char/putty.png',
        'head': './img/phantom-char/putty-head.png'
    },
    {
        'key': 4,
        'name': 'Walnut',
        'gender': 'Male',
        'type': 'Human',
        'weight': 154,
        'age': 20,
        'height': `6'`,
        'ability': 'Ability of Awakening, Psycho Burgundy',
        'desc': 'Walnut is a Chroma, like Marona, but he is known for playing dirty tricks and stealing work from other Chromas. He seems to have an unusually high desire for money, but his ultimate goals are unknown.',
        'img': './img/phantom-char/walnut.png',
        'head': './img/phantom-char/walnut-head.png'
    }
]

export default PhantomData;

